import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getPosts, deletePost } from "../../store/actions/postsActions";
import { Link } from "react-router-dom";
import { Table, Spin, Button, Tag, Modal } from "antd";
import LinkModal from "./LinkModal";
import { DeleteOutlined, EditOutlined, LinkOutlined } from "@ant-design/icons";
const { confirm } = Modal;

function PostsList({ posts, getPosts, deletePost, user }) {
  const [loading, setLoading] = useState(true);
  const [selectedPostID, setSelectedPostID] = useState(null);
  const [postLinkModalVisible, setPostLinkModalVisible] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      await getPosts();
      setLoading(false);
    };
    getData();
  }, [getPosts]);

  const filteredPosts = (posts) => {
    if (user.clearanceLevel === "admin") return posts;
    return posts.filter((post) => {
      return (
        post.authors
          .map((author) => {
            return author.email;
          })
          .indexOf(user.email) !== -1
      );
    });
  };

  const showPostLinkModal = (id) => {
    setSelectedPostID(id);
    setPostLinkModalVisible(true);
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Summary",
      dataIndex: "summary",
      key: "summary",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => new Date(date * 1000).toISOString().slice(0, 10),
    },
    {
      title: "Free Content",
      dataIndex: "isFree",
      key: "isFree",
      render: (isFree) => (isFree ? "Yes" : "No"),
    },
    {
      title: "Authors",
      dataIndex: "authors",
      key: "authors",
      render: (authors) => authors.map((a) => <Tag>{a.displayName}</Tag>),
    },
    {
      title: "Action",
      key: "action",
      width: "200px",
      render: (_, record) => (
        <Button.Group>
          <Button type="info" onClick={() => showPostLinkModal(record.id)}>
            <LinkOutlined />
          </Button>
          {user.isAuthor || user.clearanceLevel === "admin" ? (
            <Button type="info">
              <Link to={`/posts/${record.id}/edit`}>
                <EditOutlined />
              </Link>
            </Button>
          ) : null}
          {user.clearanceLevel === "admin" ? (
            <Button
              type="danger"
              onClick={() =>
                confirm({
                  title: "Do you Want to delete this Post?",
                  okText: "Yes",
                  okType: "danger",
                  cancelText: "No",
                  onOk() {
                    deletePost(record.id);
                  },
                })
              }
            >
              <DeleteOutlined />
            </Button>
          ) : null}
        </Button.Group>
      ),
    },
  ];

  return (
    <div>
      {user.isAuthor || user.clearanceLevel === "admin" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "1rem",
          }}
        >
          <Button type="primary">
            <Link to="/posts/new">Create Post</Link>
          </Button>
        </div>
      ) : null}
      <Spin spinning={loading}>
        <Table columns={columns} dataSource={filteredPosts(posts)} />
      </Spin>

      <LinkModal
        visible={postLinkModalVisible}
        toggle={() => setPostLinkModalVisible((c) => !c)}
        selectedPostID={selectedPostID}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  posts: state.posts.posts,
});
export default connect(mapStateToProps, { getPosts, deletePost })(PostsList);
